import groupRoleApi from "api/groupRoleApi";

export { useGroupRoleActions };

function useGroupRoleActions() {
   const getGroupRoleList = async (params) => {
      try {
         return await groupRoleApi.gets(params);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   const addNewGroupRole = async (data) => {
      try {
         return await groupRoleApi.post(data);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   const updateGroupRole = async (id, data) => {
      try {
         return await groupRoleApi.put(id, data, {
            providerName: "R",
            providerKey: id,
         });
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   const deleteGroupRole = async (id) => {
      try {
         return await groupRoleApi.del(id);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   const getRoleDetail = async (id) => {
      try {
         return await groupRoleApi.get(id);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   const getRolesByUserId = async (userId) => {
      try {
         return await groupRoleApi.getRolesByUserId(userId);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   const getRoleById = async (roleId) => {
      try {
         return await groupRoleApi.getRoleById(roleId);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   const updateRoleById = async (roleId, data) => {
      try {
         return await groupRoleApi.updateRoleById(roleId, data);
      } catch (error) {
         console.log(error);
         throw error;
      }
   };

   return {
      getRoleById,
      getRolesByUserId,
      addNewGroupRole,
      deleteGroupRole,
      getGroupRoleList,
      updateGroupRole,
      getRoleDetail,
      updateRoleById,
   };
}
